import React, { Context } from 'react'
import HierarchyWiseItemsTableStore from '../stores/HierarchyWiseItemsTableStore'

export type TableContextValue = {
  tableStore: HierarchyWiseItemsTableStore
  translationKey?: string
}

const TableContext: Context<TableContextValue> = React.createContext({
  tableStore: null
})

export default TableContext
